import { AbstractCollection } from '../../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../../abstract/Document';
import { Suppliers } from '../../Suppliers';
import type { Lead } from '../Leads';
import { ILeadScheduledMessage, IScheduledTemplateType } from './ScheduledMessages.types';
import { where } from 'firebase/firestore';

@Identifiable
@Timestampable
@Untrackable
export class ScheduledMessage extends AbstractDocument<ILeadScheduledMessage> {
  readonly collections = {};
}

export class ScheduledMessages extends AbstractCollection<ScheduledMessage, ILeadScheduledMessage> {
  static path = 'scheduled-messages';

  constructor(document: Lead) {
    super(document.collection(ScheduledMessages.path), ScheduledMessage);
  }

  get supplier() {
    return Suppliers._.getById(this.reference.parent!.parent.parent!.id);
  }

  async getUnprocessedFollowUps() {
    return this.query([where('processed', '==', false), where('type', '==', IScheduledTemplateType.FollowUp)]).get();
  }
}
